import React from 'react';
import Callout from './callout';
export default function index({ bodyCopy }) {
  return (
    <Callout calloutTitle="AVEED<sup>&reg;</sup>&nbsp;Resources Page" buttonTitle="View Now" buttonLink="/resources/" bodyCopy={bodyCopy}>
      <p>Get downloadable Patient Brochure, Medication Guide, rebate info, and more.</p>
    </Callout>
  )
}
